export enum DistributionTypeEnum {
  rent = 'RENT',
  buy = 'BUY'
}
